import img1 from "../images/1.jpg";
import img2 from "../images/2.jpg";
import img3 from "../images/3.jpg";
import img4 from "../images/4.jpg";

const projects = [
  { id: "01", color: "#b5b5b2", image: img1, name: "Hansika" },
  { id: "02", color: "#b3a8b3", image: img2, name: "Kalidas" },
  { id: "03", color: "#a3b1ae", image: img3, name: "Muralidhar" },
  { id: "04", color: "#b0aeac", image: img4, name: "Palash" },
];

export default projects;
